export type DiscountType = 'PERCENT' | 'FLAT';

export interface DiscountState {
  value: string;
  type: DiscountType;
}

export const money = (value: number) =>
  `৳${Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;

/**
 * Keeps a discount field a plain text input while guaranteeing the value is
 * numeric: strips every non-digit/non-dot character and allows at most one
 * decimal point with two decimal places.
 */
export function sanitizeDecimalInput(raw: string): string {
  let value = raw.replace(/[^0-9.]/g, '');
  const firstDot = value.indexOf('.');
  if (firstDot !== -1) {
    value = value.slice(0, firstDot + 1) + value.slice(firstDot + 1).replace(/\./g, '');
  }
  const [intPart, decPart] = value.split('.');
  if (decPart !== undefined) {
    value = `${intPart}.${decPart.slice(0, 2)}`;
  }
  return value;
}

/** Resolves the monetary value of a discount for live totals. */
export function resolveDiscountAmount(base: number, value: string, type: DiscountType): number {
  const num = parseFloat(value);
  if (!value || !Number.isFinite(num) || num <= 0) return 0;
  if (type === 'PERCENT') {
    return Math.round(((base * Math.min(num, 100)) / 100) * 100) / 100;
  }
  return Math.round(Math.min(num, base) * 100) / 100;
}

export const round2 = (n: number) => Math.round(n * 100) / 100;
